import { render, staticRenderFns } from "./need-help.vue?vue&type=template&id=139d54b2&scoped=true"
import script from "./need-help.vue?vue&type=script&lang=js"
export * from "./need-help.vue?vue&type=script&lang=js"
import style0 from "./need-help.vue?vue&type=style&index=0&id=139d54b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d54b2",
  null
  
)

export default component.exports